import React from "react";
import { ChevronDownDDS } from "../../../../asset";

const MSSDisplaySkillset = ({
  listSkillset,
  className,
  togglerClassName,
  placeholder,
  disabled,
  ...attrs
}) => {
  return (
    <div
      className={"dropdown".concat(className ? ` ${className}` : "")}
      {...attrs}
    >
      <div
        className={
          disabled ? "container-mss-disabled" : "container-mss-enabled"
        }
      >
        {!listSkillset || listSkillset.length === 0 ? (
          <span className="text-base text-gray-200 opacity-70">
            No Skillset Selected
          </span>
        ) : (
          <div className="max-w-[420px] flex flex-wrap gap-2 my-2">
            {listSkillset.map((item, index) => (
              <span
                className={
                  disabled ? "value-mss-disabled" : "value-mss-enabled"
                }
                key={index}
              >
                {item}
              </span>
            ))}
          </div>
        )}
        <img src={ChevronDownDDS} alt="img-chevron-down" />
      </div>
    </div>
  );
};

export default MSSDisplaySkillset;
